import React from 'react';
import { Lock, Loader2 } from 'lucide-react';

interface ConcurrencyBannerProps {
  /** Number of docs currently being modified by other users */
  lockedCount: number;
  /** True when a databook generation is in progress */
  databookGenerating: boolean;
  /** True when an upload is in progress */
  uploadInProgress: boolean;
}

/**
 * Lightweight banner showing concurrent operation indicators.
 * Renders nothing if no operations are in progress.
 */
export const ConcurrencyBanner: React.FC<ConcurrencyBannerProps> = ({
  lockedCount,
  databookGenerating,
  uploadInProgress,
}) => {
  const items: { icon: React.ReactNode; text: string }[] = [];

  if (lockedCount > 0) {
    items.push({
      icon: <Lock className="h-3.5 w-3.5" />,
      text: `${lockedCount} documento${lockedCount > 1 ? 's' : ''} em edição por outro usuário`,
    });
  }

  if (databookGenerating) {
    items.push({
      icon: <Loader2 className="h-3.5 w-3.5 animate-spin" />,
      text: 'Geração de Databook em andamento — listagem em modo leitura',
    });
  }

  if (uploadInProgress) {
    items.push({
      icon: <Loader2 className="h-3.5 w-3.5 animate-spin" />,
      text: 'Upload em progresso...',
    });
  }

  if (items.length === 0) return null;

  return (
    <div className="rounded-md bg-warning/10 border border-warning/30 px-3 py-2 space-y-1">
      {items.map((item, i) => (
        <div key={i} className="flex items-center gap-2 text-xs text-warning">
          {item.icon}
          <span>{item.text}</span>
        </div>
      ))}
    </div>
  );
};
